<div class="statistical-profile-container">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
        <div *ngIf="showUserTypeSelect" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <mat-select app-small-select formControlName="userType"
                        placeholder="{{('Type of consumer'|i18n) + '*'}}">
                <mat-option *ngFor="let userType of userTypes" [value]="userType">
                    <em>{{userType|userType|i18n}}</em>
                </mat-option>
            </mat-select>
            <app-icon icon-color-h name="fas-info-circle"
                      [title]="'Classifications of low voltage consumer of injection or both injection and absorption (prosumer) defined by ARERA.'|i18n"></app-icon>&nbsp;
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
            <span class="txt-s-10-4">{{'Mode'|i18n}}</span>
            <mat-radio-group formControlName="rateMode" fxLayout="row" fxLayoutGap="35px" color="primary">
                <mat-radio-button app-radio-button *ngFor="let mode of rateModes"
                                  [value]="mode" class="txt-p-16-4">
                    {{mode|radioRateMode|i18n}}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div *ngIf="isConsumer && !isPlant" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
             class="panel mb-20">
            <span class="txt-p-16-4">{{'Absorption statistical data'|i18n}}</span>
            <button app-ghost-button (click)="onClickEnterData()"
                    [disabled]="!form.valid" fxLayoutGap="10px">
                <ng-container *ngIf="!statisticalProfile">
                    <span>{{'Enter absorption data'|i18n}}</span>
                    <app-icon name="fal-arrow-right"></app-icon>
                </ng-container>
                <ng-container *ngIf="statisticalProfile">
                    <span>{{'Edit absorption data'|i18n}}</span>
                    <app-icon name="fal-magic"></app-icon>
                </ng-container>
            </button>
        </div>
        <div *ngIf="isProsumer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="panel mb-20">
            <span class="txt-p-16-4">{{'Prosumer statistical data'|i18n}}</span>
            <button app-ghost-button (click)="onClickEnterData()"
                    [disabled]="!form.valid" fxLayoutGap="10px">
                <ng-container *ngIf="!statisticalProfile">
                    <span>{{'Enter prosumer data'|i18n}}</span>
                    <app-icon name="fal-arrow-right"></app-icon>
                </ng-container>
                <ng-container *ngIf="statisticalProfile">
                    <span>{{'Edit prosumer data'|i18n}}</span>
                    <app-icon name="fal-magic"></app-icon>
                </ng-container>
            </button>
        </div>
        <div *ngIf="isProducer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="panel mb-20">
            <span class="txt-p-16-4">{{'Injection statistical data'|i18n}}</span>
            <button app-ghost-button (click)="onClickEnterData()"
                    [disabled]="!form.valid" fxLayoutGap="10px">
                <ng-container *ngIf="!statisticalProfile">
                    <span>{{'Enter injection data'|i18n}}</span>
                    <app-icon name="fal-arrow-right"></app-icon>
                </ng-container>
                <ng-container *ngIf="statisticalProfile">
                    <span>{{'Edit injection data'|i18n}}</span>
                    <app-icon name="fal-magic"></app-icon>
                </ng-container>
            </button>
        </div>
        <div *ngIf="isPlant" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="panel mb-20">
            <span class="txt-p-16-4">{{'Production statistical data'|i18n}}</span>
            <button app-ghost-button (click)="onClickEnterData()"
                    [disabled]="!form.valid" fxLayoutGap="10px">
                <ng-container *ngIf="!statisticalProfile">
                    <span>{{'Enter production data'|i18n}}</span>
                    <app-icon name="fal-arrow-right"></app-icon>
                </ng-container>
                <ng-container *ngIf="statisticalProfile">
                    <span>{{'Edit production data'|i18n}}</span>
                    <app-icon name="fal-magic"></app-icon>
                </ng-container>
            </button>
        </div>
    </form>
    <button mat-stroked-button color="primary" class="clear-button"
            [disabled]="!clearEnabled"
            (click)="onClickClear()">
        {{'Reset'|i18n}}
    </button>
</div>

<ng-template #enterData let-data let-close="close">
    <div>
        <app-pod-profile [userType]="userType"
                         [rateMode]="rateMode"
                         [resource]="resource"
                         [statisticalProfile]="statisticalProfile"
                         [podStatisticalProfileTemplates]="podStatisticalProfileTemplates"
                         [pvPlantStatisticalProfileTemplates]="pvPlantStatisticalProfileTemplates"
                         [windPlantStatisticalProfileTemplates]="windPlantStatisticalProfileTemplates"
                         (values)="data.values = $event"
                         (valid)="data.valid = $event">
        </app-pod-profile>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24">
        <button app-large-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            {{'Save'|i18n}}
        </button>
    </div>
</ng-template>
